module.exports = __webpack_public_path__ + "img/souris_chine.24461381.jpeg";